<template>
  	<div class="stores">
    	<div class="breadcrumb">门店管理 > 门店列表</div>
	    <div class="searchBtn">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<el-button size='small' type="warning" @click="edit" plain>修改</el-button>
			<el-button size='small' type="danger" @click="del" plain>删除</el-button>
	    </div>
	    <!-- 列表 -->
    	<div class="main">
      		<template>
        		<el-table ref="multipleTable" :data="tableData" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
		          	<el-table-column prop="id" label="ID"></el-table-column>
		          	<el-table-column prop="name" label="名字" show-overflow-tooltip></el-table-column>
		          	<el-table-column prop="introPic" label="图片">
			            <template slot-scope="scope">
			            	<div class="imgWidth">
			            		<img :src="scope.row.introPic"  />
			            	</div>
			            </template>
		          	</el-table-column>
		          	<el-table-column prop="createTime" :formatter="dateFormat" label="创建时间"></el-table-column>
        		</el-table>
      		</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
    	</div>
    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="80px">
	        	<el-form-item label="名称" prop="name">
	          		<el-input v-model="ruleForm.name" placeholder="请输入名称" style="width:80%"></el-input>
	        	</el-form-item>
	        	<!-- 上传图片 -->
	        	<el-form-item label="封面图片" prop="introPic">
	          		<el-input v-model="ruleForm.introPic" placeholder style="width:80%"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
	            		<img v-if="ruleForm.introPic" :src="ruleForm.introPic" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
	          		</el-upload>
	        	</el-form-item>
		        <el-form-item label="介绍" prop="introText">
		          	<el-input type="textarea" v-model="ruleForm.introText" placeholder="请输入类型" style="width:80%" :rows="5"></el-input>
		        </el-form-item>
		        <el-form-item label prop="id" v-show="isShow">
		          	<el-input v-model="ruleForm.id" placeholder></el-input>
		        </el-form-item>
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
	      	</span>
    	</el-dialog>
  	</div>
</template>

<script>
export default {
  	components: {},
	mounted() {
	    this.init();
	},
  	data() {
    	return {
      		searchForm: {// 搜索参数
		        pageNum: 1,
		        limit: 5
      		},
	      	headers: {
	        	xqiao_token: localStorage.getItem("token") 
	      	},
      		tableData: [],
      		pageNum: 0,
      		limit: 5,
      		totalPage: 10,
      		currentRow: "",
      		ruleForm: {
		        name: "",
		        introPic: "",
		        introText: "",
		        id: ""
      		},
      		ruleForms: {
		        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
		        introPic: [{ required: true, message: "图片不能为空" }]
      		},
		    dialogVisible: false,
		    isShow: false,
		    imageUrl: "",
		    // off: false,
		    percentage: 0,
		    tmpFiles: process.env.API_ROOT + "/tmpFiles"
    	};
  	},
  	methods: {
	    //初始化表格数据
	    init() { 
	      	let params = this.searchForm
	      	this.$get("/stores", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
		            this.tableData = res.data.list;
		            this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
		        }
	        })
	        .catch(() => {
	          console.log();
	        });
	    },
	    onEditeClick(row){ 
	    },
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.searchForm.pageNum = val;
	      	this.init();
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	      	}
	      	done();
	    },
	    //选择需要修改的权限
	    handleCurrentChange(val) {
	      	if (val) {
	        	this.currentRow = val.id;
	      	}
	    },
    	openDialog() {},
	    add(row) {
	    	this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.currentRow='';
	      	this.dialogVisible = true;
	    },
	    onSubmit() {
	      	//通过表单id判断，如果id有值为修改，否则是添加
	      	if (this.ruleForm.id) {
	        	console.log("修改");
	        	this.$refs.ruleForm.validate(valid => {
		          	if (valid) {
		            	this.loading = true;
		            	this.$axios.put("/stores/" + this.ruleForm.id, JSON.stringify(this.ruleForm))
		              	.then(res => {
		                	this.loading = false;
		                	if (res.data.code == 0) {
		                  		this.$message({
		                    		message: "修改成功",
		                    		type: "success"
		                  		});
		                  		this.searchForm.pageNum=1;
		                  		this.currentRow='';
		                  		this.pageNum=1;
		                  		this.init();
		                  		this.dialogVisible = false;
		                	} else {
				                this.$message({
				                    message: res.message,
				                    type: "warning"
				                });
			                  	return false;
		                	}
		              	})
			            .catch(() => {
			            	this.loading = false;
			            });
		          	} else {
			            console.log("error submit!!");
			            return false;
		          	}
	        	});
	      	} else {
	        	console.log("添加");
	        	this.$refs.ruleForm.validate(valid => {
		          	if (valid) {
		            	this.loading = true;
		            	this.$post("/stores", JSON.stringify(this.ruleForm))
		              	.then(res => {
		                	this.loading = false;
		                	if (res.code == 0) {
				                this.$message({
				                    message: "添加成功",
				                    type: "success"
				                });
				                this.searchForm.pageNum=1;
				                this.currentRow='';
		                  		this.pageNum=1;
				                this.init();
				                this.dialogVisible = false;
		                	} else {
				                this.$message({
				                    message: res.message,
				                    type: "warning"
				                });
				                return false;
		              		}
		              	})
		              	.catch(() => {
		                	this.loading = false;
		              	});
		          	} else {
		            	console.log("error submit!!");
		            	return false;
		          	}
	        	});
	      	}
	    },
	    edit() {
	      	this.off = true;
	      	var currentRowId = this.currentRow;
	      	console.log(currentRowId);
	      	if (currentRowId) {
		        this.$get("/stores/" + currentRowId)
		        .then(res => {
		            if (res.code == 0) {
		              	this.dialogVisible = true;
		              	this.$nextTick(function() {
		                	this.ruleForm = res.data;
		              	});
		            }
		        })
	          	.catch(() => {});
	      	} else {
	        	this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    del() {
	      	var that = this;
	      	var currentRowId = that.currentRow;
	      	console.log(currentRowId);
	      	if (currentRowId) {
		        that.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
		        })
	          	.then(() => {
	            	that.$axios.delete("/stores/" + currentRowId)
	              	.then(function(res) {
	                	console.log(res);
	                	if (res.data.code == 0) {
	                  		console.log(" 删除成功 ");
	                  		that.$message({
			                    message: "删除成功",
			                    type: "success"
	                  		});
	                  		that.pageNum = 1;
	                  		that.currentRow='';
	                  		that.searchForm.pageNum=1;
	                  		that.init();
	                  		that.dialogVisible = false;
	                	} else {
	                  		that.errorMsg("操作失败");
	                	}
	              	})
	              	.catch(function(err) {
	                	console.log(err);
	              	});
	          	})
	          	.catch(() => {});
	      	} else {
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    //时间格式化
	    dateFormat: function(row, column) {
	      	var date = row[column.property];
	      	if (date == undefined) {
	        	return "";
	      	}
	      return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
	    },
	    handleAvatarSuccess(res, file) {
	      	console.log(res);
	      	this.ruleForm.introPic = res.data.url;
	    },
	    beforeAvatarUpload(file) {
	      	const isJPG = file.type === "image/jpeg";
	      	const isLt2M = file.size / 1024 / 1024 < 2;

	      	// if (!isJPG) {
	      	//   this.$message.error('上传头像图片只能是 JPG 格式!');
	      	// }
	      	// if (!isLt2M) {
	      	//   this.$message.error('上传头像图片大小不能超过 2MB!');
	      	// }
	      	return;
	    }
  	}
};
</script>

<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
.imgWidth{
	width: 50px;
	height: 50px;
	border:1px solid #ccc;
	display:flex;
  	align-items:center;
}
.imgWidth img,.avatar{
	max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/stores/index.vue